import {GET_ERRORS_ERROR} from "../../../reducers/errorsReducer";


export const getErrorsError = (error) =>{
    return {
        type: GET_ERRORS_ERROR,
        payload: {error}
    }
}